import React from "react";
import { useSelector } from "react-redux";
import { useAuthContext } from "../../contexts/AuthContext";
import NiceModal from "@ebay/nice-modal-react";
import styled from "styled-components";

const SendNotificationLink = styled.div`
  font-weight: bold;
  align-self: flex-end;
  margin-bottom: 10px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Audience = ({
  display,
  socketRef,
  liveEvent,
  activeUsers,
  inactiveUsers,
}) => {
  const { activeUser } = useAuthContext();
  const token = useSelector((state) => state.users.token);
  const event_id = liveEvent?.public_id ?? liveEvent?.id;

  console.log("AUDIENCE ACTIVE USERS: ", activeUsers);
  console.log("AUDIENCE INACTIVE USERS: ", inactiveUsers);

  return (
    <div
      style={{
        display: display ? "flex" : "none",
        flexDirection: "column",
        paddingTop: "20px",
        maxHeight: "95vh",
        paddingRight: "20px",
        width: "103%",
        overflow: "auto",
      }}
    >
      <SendNotificationLink
        onClick={() => {
          NiceModal.show("notification-modal", {
            position: { top: 400, right: 100 },
            allUsers: [...(activeUsers ?? []), ...(inactiveUsers ?? [])],
          });
        }}
      >
        <i
          className="fas fa-comment"
          style={{ color: "#16a34a", marginRight: "5px" }}
        ></i>
        Send Notification
      </SendNotificationLink>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div style={{ fontSize: "16px", fontWeight: "600" }}>Active Users</div>
        <div
          style={{
            backgroundColor: "#dcfce8",
            width: "50px",
            borderRadius: "10px",
            color: "#16a34a",
            fontSize: "13px",
            fontWeight: "600",
            textAlign: "center",
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          <i
            className="fas fa-user"
            style={{ fontSize: "10px", marginRight: "5px" }}
          ></i>{" "}
          {activeUsers?.length ?? 0}
        </div>
      </div>
      <ul>
        {activeUsers?.length > 0 ? (
          activeUsers.map((user, index) => (
            <li
              key={index}
              style={{
                fontSize: "16px",
                marginBottom: "10px",
                width: "100%",
                height: "50px",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: "0 16px",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  height: "30px",
                  width: "30px",
                  borderRadius: "50%",
                  marginRight: "10px",
                  position: "relative",
                  backgroundColor: "rgba(220, 252, 232, 0.8)",
                }}
              >
                {user?.icon_background ? (
                  <img
                    src={require(`../../assets/live-event-icons/${user.icon_background}.png`)}
                    alt="User Avatar"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                    }}
                  />
                ) : null}
                {user?.icon_name ? (
                  <img
                    src={require(`../../assets/live-event-icons/${user.icon_name}.png`)}
                    alt="User Avatar"
                    style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      position: "absolute",
                      top: "5px",
                      left: "5px",
                    }}
                  />
                ) : null}
              </div>
              <div style={{ fontWeight: 600, marginRight: 10 }}>
                {user?.nickname?.replace(" null", "") ?? `Unknown User`}
              </div>
              <div
                style={{
                  justifySelf: "flex-end",
                  flexGrow: 1,
                  textAlign: "right",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  console.log("!!! USER MESSAGE CLICKED: ", user);
                  NiceModal.show("message-modal", {
                    position: {
                      top: e.clientY + 150,
                      left: e.clientX - 250,
                    },
                  }).then((message) => {
                    console.log(
                      "!!! MESSAGE SENT: ",
                      message,
                      event_id,
                      liveEvent.broadcast_token,
                      activeUser?.public_id,
                      user.id
                    );
                    socketRef.current.emit("live-event-direct-message", {
                      token: token,
                      event_id: event_id,
                      broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                      from_user_id: activeUser?.public_id, // user uuid
                      to_user_id: user.id, // user id
                      message: message,
                      nickname: `${activeUser?.firstname} ${activeUser?.lastname}`,
                    });
                  });
                }}
              >
                <i className="fas fa-comment" style={{ color: "#16a34a" }}></i>
              </div>
            </li>
          ))
        ) : (
          <li
            style={{
              fontSize: "16px",
              marginBottom: "10px",
              width: "100%",
              height: "50px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 16px",
            }}
          >
            No users connected.
          </li>
        )}
      </ul>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "40px",
          marginBottom: "10px",
        }}
      >
        <div style={{ fontSize: "16px", fontWeight: "600" }}>
          Inactive Users
        </div>
        <div
          style={{
            width: "50px",
            borderRadius: "10px",
            fontSize: "13px",
            fontWeight: "600",
            textAlign: "center",
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          }}
        >
          <i
            className="fas fa-user-slash"
            style={{ fontSize: "10px", marginRight: "5px" }}
          ></i>{" "}
          {inactiveUsers?.length ?? 0}
        </div>
      </div>
      <ul>
        {inactiveUsers?.length > 0 ? (
          inactiveUsers.map((user, index) => (
            <li
              key={index}
              style={{
                fontSize: "16px",
                marginBottom: "10px",
                width: "100%",
                height: "50px",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: "0 16px",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  opacity: 0.6,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  style={{
                    height: "30px",
                    width: "30px",
                    borderRadius: "50%",
                    backgroundColor: "#d9ded2",
                    marginRight: "10px",
                    position: "relative",
                  }}
                >
                  {user?.icon_background ? (
                    <img
                      src={require(`../../assets/live-event-icons/${user.icon_background}.png`)}
                      alt="User Avatar"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                      }}
                    />
                  ) : null}
                  {user?.icon_name ? (
                    <img
                      src={require(`../../assets/live-event-icons/${user.icon_name}.png`)}
                      alt="User Avatar"
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "5px",
                        left: "5px",
                      }}
                    />
                  ) : null}
                </div>
                <div style={{ fontWeight: 600, marginRight: 10 }}>
                  {user.nickname}
                </div>
              </div>
              <div
                style={{
                  justifySelf: "flex-end",
                  flexGrow: 1,
                  textAlign: "right",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  console.log("!!! USER MESSAGE CLICKED: ", user);
                  NiceModal.show("message-modal", {
                    position: {
                      top: e.clientY + 150,
                      left: e.clientX - 250,
                    },
                  }).then((message) => {
                    console.log(
                      "!!! MESSAGE SENT: ",
                      message,
                      event_id,
                      liveEvent.broadcast_token,
                      activeUser?.public_id,
                      user.id
                    );
                    socketRef.current.emit("live-event-direct-message", {
                      token: token,
                      event_id: event_id,
                      broadcast_token: liveEvent?.broadcast_token, // Replace with actual token if needed
                      from_user_id: activeUser?.public_id, // user uuid
                      nickname: `${activeUser?.firstname} ${activeUser?.lastname}`,
                      to_user_id: user.id, // user id
                      message: message,
                    });
                  });
                }}
              >
                <i className="fas fa-comment" style={{ color: "#16a34a" }}></i>
              </div>
            </li>
          ))
        ) : (
          <li>No inactive users.</li>
        )}
      </ul>
    </div>
  );
};

export default Audience;
